import { useEffect, useState } from 'react'

import { clearSession, getUser } from '../auth'
import { applyTheme, getTheme, setTheme, type Theme } from '../theme'
import { LineIcon } from './LineIcon'

/** Header controls shared by the staff app (`App.tsx` Layout) and the
 *  customer portal (`PortalLayout`). */

export function UserMenu() {
  const user = getUser()
  if (!user) return null
  const signOut = () => {
    clearSession()
    window.location.href = '/login'
  }
  return (
    <span className="user-menu">
      <span className="user-menu__email" data-testid="auth-user-email">
        {user.email}
      </span>
      <button
        type="button"
        onClick={signOut}
        data-testid="sign-out-btn"
        className="user-menu__signout"
      >
        Sign out
      </button>
    </span>
  )
}

/** Light/dark switch — persisted; default follows the OS preference.
 *  Monochrome line icons (currentColor), not colored emoji. */
export function ThemeToggle() {
  const [theme, setThemeState] = useState<Theme>(getTheme)
  useEffect(() => applyTheme(theme), [theme])
  const toggle = () => {
    const next: Theme = theme === 'dark' ? 'light' : 'dark'
    setTheme(next)
    setThemeState(next)
  }
  const label = theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'
  return (
    <button type="button" className="theme-toggle" onClick={toggle} data-testid="theme-toggle" title={label} aria-label={label}>
      <LineIcon size={14}>
        {theme === 'dark' ? (
          // Sun
          <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
          </>
        ) : (
          // Moon
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
        )}
      </LineIcon>
    </button>
  )
}
